import React from 'react';
import './SearchBar.css';

const sortByOptions = {
    'Best Match': 'best_match',
    'Highest Rated': 'rating',
    'Most Reviewed': 'review_count'
}

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.renderSortByOptions = this.renderSortByOptions.bind(this);
    }

    renderSortByOptions() {
        const options = Object.keys(sortByOptions);
        return options.map(option => {
            return <li key={option}>{option}</li>
        });
    }

    render() {
        return (
            <section className='main-searchBar'>
                <ul className='main-searchBar__list'>
                    {this.renderSortByOptions()}
                </ul>
                <article className='main-searchBar__inputs'>
                    <input 
                        type='text'
                        placeholder='Business'/>
                    <input 
                        type='text'
                        placeholder='Where?'/>
                </article>
                <button className='main-searchBar__btn'>Let's Go</button>
            </section>
        )
    }
}

export default SearchBar;